export const extractUrlHostname: (sourceUrl: string) => string | undefined = (
	sourceUrl: string,
) => {
	let url;
	try {
		url = new URL(sourceUrl);
	} catch {
		return undefined;
	}
	return url.hostname;
};
